/* eslint-disable */
import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import GlobalDispatchContext from '~/context/GlobalDispatchContext';
import GlobalStateContext from '~/context/GlobalStateContext';
import { DataLayer } from '~/components/DataLayer';
import { TabContent } from '..';
import './DesktopTabs.scss';

const classes = {
	root: 'DesktopTabs',
	rootFx: 'DesktopTabs-effect-slide-fade',
	content: 'DesktopTabs-content',
	list: 'DesktopTabs-list',
	accordionContent: '',
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	mobile: PropTypes.bool,
	data: PropTypes.arrayOf(PropTypes.object),
};

const defaultProps = {
	className: '',
	classes,
	mobile: undefined,
	data: [],
};

export const DesktopTabs = ({
	className,
	classes,
	children,
	data: info,
	...props
}) => {
	const globalDispatchContext = React.useContext(GlobalDispatchContext);
	const globalStateContext = React.useContext(GlobalStateContext);
	const [data] = React.useState(info);
	const [currentIndex, setCurrentIndex] = React.useState(0);

	React.useEffect(() => {
		const index = data.findIndex(
			(item) => item.slug === globalStateContext.menuSelectedAnchor
		);
		if (index > -1) {
			setCurrentIndex(index);
		}
	}, [globalStateContext.menuSelectedAnchor]);

	const onRadioChange = (index, evt) => {
		DataLayer.push('AboutPage_ClicouTab', data[index].title);
		globalDispatchContext.openAccordionItem(data[index].slug);
		if (index != currentIndex) {
			DataLayer.push('AboutPage_ClicouTab_Close', data[currentIndex].title);
		}
	};

	const renderTab = (item, index, list) => {
		return (
			<React.Fragment key={index}>
				<input
					type="radio"
					name="AboutPage-tabs"
					id={item.slug}
					data-ui-anchor={item.slug}
					defaultChecked={false}
					onClick={() => setCurrentIndex(index)}
					onChange={onRadioChange.bind(this, index)}
					className={cls({
						['tab-content-first']: !index,
						[`tab-content-${index + 1}`]: index > 0 && index < list.length - 1,
						[`tab-content-last`]: index === list.length - 1,
						['is-checked']: index === currentIndex,
					})}
				/>
				<label htmlFor={item.slug}>
					<i className={'icon-bolt'} />
					<span dangerouslySetInnerHTML={{ __html: item.title || '&nbsp;' }} />
				</label>
			</React.Fragment>
		);
	};

	const renderTabs = (list) => {
		return list.map(renderTab);
	};

	const renderContentItem = (item, index, list) => {
		return (
			<li
				key={index}
				className={cls('tab-content', {
					['tab-content-first']: !index,
					[`tab-content-${index + 1}`]: index > 0 && index < list.length - 1,
					[`tab-content-last`]: index === list.length - 1,
				})}
			>
				<TabContent
					{...props}
					className={cls(classes.accordionContent)}
					data={item}
				/>
			</li>
		);
	};

	const renderContent = (list) => {
		return list.map(renderContentItem);
	};
	


	return (
		<div className={cls(classes.root, classes.rootFx, className)}>
			<div className={cls(classes.content)}>
				{renderTabs(data)}
				<ul className={cls(classes.list)}>{renderContent(data)}</ul>
			</div>
		</div>
	);
};

DesktopTabs.displayName = 'DesktopTabs';
DesktopTabs.propTypes = propTypes;
DesktopTabs.defaultProps = defaultProps;
export default DesktopTabs;
